export const BUILDS = {
  type: 'Builds',
  hasComments: true,
  needsJiraAuth: true
};

//Metrics Page Types
export const CASEMETRICS = {
  type: 'CaseMetrics',
  hasComments: false,
  needsJiraAuth: true
};
export const ENGINEMETRICS = { type: 'EngineMetrics' };
export const PERFORMANCEMETRICS = { type: 'PerformanceMetrics' };
export const ARTIFACTSMETRICS = { type: 'ArtifactsMetrics' };
export const JOBBENCHMARK = { type: 'JobBenchmark' };
export const RELEASEMETRICS = {
  type: 'ReleaseMetrics',
  needsJiraAuth: true
};

//Regression Page Types
export const ARTIFACTREGRESSION = {
  type: 'ArtifactRegression',
  hasComments: true,
  needsJiraAuth: true
};
export const DIFFTOOLREGRESSION = {
  type: 'DifftoolRegression',
  hasComments: true,
  needsJiraAuth: true
};
export const UITESTS = {
  type: 'UITests',
  hasComments: true,
  needsJiraAuth: true
};
export const TESTSTUDIO = {
  type: 'TestStudio',
  hasComments: true,
  needsJiraAuth: true
};
export const EXPORTTESTS = {
  type: 'ExportTests',
  hasComments: true,
  needsJiraAuth: true
};
export const REMOTEACQUIREREGRESSION = {
  type: 'RemoteAcquireRegression',
  hasComments: true,
  needsJiraAuth: true
};
export const CASEAMENDINGTESTS = {
  type: 'CaseAmendingTests',
  hasComments: true,
  needsJiraAuth: true
};
export const CASEAMENDINGKPPTESTS = {
  type: 'CaseAmendingkppTests',
  hasComments: true,
  needsJiraAuth: true
};
export const INSTALLERTESTS = {
  type: 'UIInstallerTests',
  hasComments: true,
  needsJiraAuth: true
};
export const AXIOMUITESTS = {
  type: 'AxiomUITests',
  hasComments: true,
  needsJiraAuth: true
};

export const ACQUISITIONTESTS = { type: 'AcquisitionTests' };

export const CLOUDTESTS = { type: 'CloudTests' };

export const CASEMERGINGTESTS = {
  type: 'CaseMergingTests',
  hasComments: true,
  needsJiraAuth: true
};


// WEBPACK FOOTER //
// src/helpers/pageTypes.js